import script from "./form-franchise.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-franchise.vue?vue&type=script&setup=true&lang=ts"

import "./form-franchise.vue?vue&type=style&index=0&id=6f43bffe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f43bffe"]])

export default __exports__